(function () {
  'use strict';

  const header = document.querySelector('[data-header]');

  function updateMegamenuTop() {
    if (!header) return;

    const headerSection = header.closest('[id^="shopify-section-"]') || header.parentElement;

    let offsetAbove = 0;
    let sibling = headerSection.previousElementSibling;

    const siblingHeights = [];

    while (sibling) {
      const pos = getComputedStyle(sibling).position;

      if (pos !== 'fixed' && pos !== 'absolute') {
        siblingHeights.push(sibling.getBoundingClientRect().height);
      }

      sibling = sibling.previousElementSibling;
    }

    const headerHeight = header.getBoundingClientRect().height;

    offsetAbove = siblingHeights.reduce((sum, h) => sum + h, 0);

    document.documentElement.style.setProperty(
      '--top-section-height',
      offsetAbove + 'px'
    );

    const megamenuTop = header.classList.contains('is-fixed')
      ? headerHeight
      : offsetAbove + headerHeight;

    document.documentElement.style.setProperty(
      '--megamenu-top',
      megamenuTop + 'px'
    );
  }


  // Sticky Header Controller
  if (header) {

    let isFixed = false;

    const isHomePage = header.dataset.homepage === "true";


    const onScroll = function () {

      const scrollY = window.scrollY;


      if (scrollY > 100) {

        if (!isFixed) {

          isFixed = true;

          header.classList.add('is-fixed');

          // Add sticky state class for logo switching
          header.classList.add('header--sticky-active');

          updateMegamenuTop();

        }

      } else {


if (isFixed) {

  isFixed = false;

  header.classList.remove('is-fixed');

  if (isHomePage) {
    header.classList.remove('header--sticky-active');
  }

  updateMegamenuTop();

}

      }

    };


    window.addEventListener(
      'scroll',
      onScroll,
      { passive: true }
    );


    window.addEventListener(
      'resize',
      updateMegamenuTop,
      { passive: true }
    );


    updateMegamenuTop();

    onScroll();

  }

if (!document.body.classList.contains('template-index')) {
  header.classList.add('header--sticky-active');
}

  // Mega Menu Overlay

  const navOverlay = document.getElementById('nav-overlay');


  function showOverlay() {

    if (navOverlay) {

      navOverlay.classList.add('is-active');

    }

  }


  function hideOverlay() {

    if (navOverlay) {

      navOverlay.classList.remove('is-active');

    }

  }



  document
    .querySelectorAll('.nav__item--has-dropdown, .nav__item--mega')
    .forEach(function (item) {


      item.addEventListener(
        'mouseenter',
        showOverlay
      );


      item.addEventListener(
        'mouseleave',
        hideOverlay
      );


      item.addEventListener(
        'focusin',
        showOverlay
      );


      item.addEventListener(
        'focusout',
        function (e) {

          if (!item.contains(e.relatedTarget)) {

            hideOverlay();

          }

        }
      );


    });



  if (navOverlay) {


    navOverlay.addEventListener(
      'click',
      function () {

        hideOverlay();

        document
          .querySelectorAll('.nav__link[aria-expanded="true"]')
          .forEach(function (link) {

            link.setAttribute(
              'aria-expanded',
              'false'
            );

          });

      }

    );

  }



  // Mobile Menu

  const mobileMenu = document.querySelector('[data-mobile-navigation]');
  const hamburger = document.querySelector('[data-hamburger]');
  const mobileClose = document.querySelector('[data-mobile-close]');
  const mobileOverlay = document.querySelector('[data-mobile-overlay]');


  let triggerBeforeOpen = null;


  function openMobile() {

    if (!mobileMenu) return;


    triggerBeforeOpen = document.activeElement;


    mobileMenu.classList.add('is-open');

    mobileMenu.setAttribute(
      'aria-hidden',
      'false'
    );


    if (hamburger) {

      hamburger.setAttribute(
        'aria-expanded',
        'true'
      );

      hamburger.classList.add(
        'is-open'
      );

    }


    document.body.style.overflow = 'hidden';

  }



  function closeMobile() {


    if (!mobileMenu) return;


    mobileMenu.classList.remove(
      'is-open'
    );


    mobileMenu.setAttribute(
      'aria-hidden',
      'true'
    );


    if (hamburger) {


      hamburger.setAttribute(
        'aria-expanded',
        'false'
      );


      hamburger.classList.remove(
        'is-open'
      );


    }


    document.body.style.overflow = '';


    if (triggerBeforeOpen) {

      triggerBeforeOpen.focus();

      triggerBeforeOpen = null;

    }


  }



  if (hamburger) {

    hamburger.addEventListener(
      'click',
      openMobile
    );

  }


  if (mobileClose) {

    mobileClose.addEventListener(
      'click',
      closeMobile
    );

  }


  if (mobileOverlay) {

    mobileOverlay.addEventListener(
      'click',
      closeMobile
    );

  }



  document.addEventListener(
    'keydown',
    function (e) {


      if (e.key === 'Escape') {


        hideOverlay();


        if (mobileMenu) {

          closeMobile();

        }


      }


    }
  );

  // Mobile menu accordion (Shop All submenu)
  document.querySelectorAll('[data-accordion-toggle]').forEach(function (btn) { btn.addEventListener('click', function (e) { var url = btn.getAttribute('data-url'); var r = btn.getBoundingClientRect(); var onChevron = e.target.closest('svg') || (e.clientX && e.clientX > r.right - 56); if (url && url !== '#' && !onChevron) { window.location.href = url; return; } var panel = document.getElementById(btn.getAttribute('aria-controls')); if (!panel) return; var open = btn.getAttribute('aria-expanded') === 'true'; btn.setAttribute('aria-expanded', open ? 'false' : 'true'); panel.hidden = open; var li = btn.closest('li'); if (li) li.classList.toggle('is-open', !open); }); });
})();